import { CdkStepper, StepperOptions, STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    forwardRef,
    Inject,
    Input,
    Optional,
    QueryList,
    SkipSelf,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatStep, MatStepper, matStepperAnimations } from '@angular/material/stepper';

@Component({
    selector: 'aum-step',
    templateUrl: 'aum-step.html',
    providers: [{ provide: ErrorStateMatcher, useExisting: AumStep }],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'aumStep',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AumStep extends MatStep {
    _progressPercentage: number = 0;
    @Input() set progressPercentage(progressPercentage: any) {
        this._progressPercentage = progressPercentage;
    }

    constructor(
        @Inject(forwardRef(() => MatStepper)) stepper: MatStepper,
        @SkipSelf() _errorStateMatcher: ErrorStateMatcher,
        _viewContainerRef: ViewContainerRef,
        @Optional() @Inject(STEPPER_GLOBAL_OPTIONS) stepperOptions?: StepperOptions,
    ) {
        super(stepper, _errorStateMatcher, _viewContainerRef, stepperOptions);
    }
}

@Component({
    selector: 'aum-horizontal-stepper',
    exportAs: 'aumHorizontalStepper',
    templateUrl: 'stepper-horizontal.html',
    styleUrls: ['stepper.scss'],
    inputs: ['selectedIndex'],
    host: {
        class: 'mat-stepper-horizontal',
        '[class.mat-stepper-label-position-end]': 'labelPosition == "end"',
        '[class.mat-stepper-label-position-bottom]': 'labelPosition == "bottom"',
        'aria-orientation': 'horizontal',
        role: 'tablist',
        orientation: 'horizontal',
    },
    animations: [matStepperAnimations.horizontalStepTransition],
    providers: [
        { provide: MatStepper, useExisting: AumHorizontalStepper },
        { provide: CdkStepper, useExisting: AumHorizontalStepper },
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AumHorizontalStepper extends MatStepper {
    /** Whether the label should display in bottom or end position. */
    @Input()
    override labelPosition: 'bottom' | 'end' = 'end';
    /** Steps that the stepper holds. */
    @ContentChildren(AumStep) override _steps: QueryList<AumStep>;
}
